<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2020-08-12 09:54:16
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2023-12-25 15:16:17
 * @FilePath: /platform/src/views/flow/BpmEditor.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="bpm-editor-container">
    <iframe
      :src="bpmEditorUrl"
      style="height: 100%;width:100%; frameborder=no"
      frameborder="no"
      border="0"
      marginwidth="0"
      marginheight="0"
    ></iframe>
  </div>
</template>
<script>
import screenfull from "screenfull";

export default {
  name: "bpm-editor",
  props: {
    defId: String
  },
  computed: {
    bpmEditorUrl: function() {
      const url = window.location.origin + "/bpm-editor/modeler.html";
      if (this.defId) {
        return `${url}?defId=${this.defId}`;
      } else {
        return url;
      }
    }
  },
  data() {
    return {
      fullscreen: false
    };
  },
  mounted() {
    window.addEventListener("message", this.receiveMsg, false);
  },
  methods: {
    receiveMsg(event) {
      if (!event || !event.data || !event.data.type) {
        return;
      }
      switch (event.data.type) {
        case "flowDesignFullscreen":
          this.toggle();
          break;
        case "flowDesignPublishSuccess":
          this.$emit("close-def-manager");
          break;
        case "flowDesignSaveSuccess":
          this.$emit("switch-config-refresh");
          break;
      }
    },
    toggle() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: "不支持全屏",
          type: "warning"
        });
        return false;
      }
      screenfull.toggle(this.$el);
      this.fullscreen = !this.fullscreen;
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMsg);
  }
};
</script>
<style scoped>
.bpm-editor-container {
  height: 100%;
}
</style>